import { render } from "./trader-profit.vue?vue&type=template&id=287b0f27"
import script from "./trader-profit.vue?vue&type=script&lang=js"
export * from "./trader-profit.vue?vue&type=script&lang=js"

import "./trader-profit.vue?vue&type=style&index=0&id=287b0f27&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__